<template>
  <div class="icon-card row">
    <div class="icon-wrapper col-md-2">
      <div :style="'color: ' + iconColor">
        <slot></slot>
      </div>
    </div>
    <div class="text-wrapper col-md-10">
      <div class="card-title">{{ title }}</div>
      <div class="card-text" v-html="text"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "icon-card",
  props: {
    iconColor: {
      type: String,
      description: "Color of the icon.",
    },
    title: {
      type: String,
      description: "Title to display at the top of the card.",
    },
    text: {
      type: String,
      description: "Text to display on the card.",
    },
  },
};
</script>

<style scoped lang="scss">
.icon-card {
  margin-bottom: 4rem;

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 6rem;
    }
  }

  .card-title {
    font-size: 1.875rem;
    font-weight: 700;
    margin-bottom: 1rem;
  }
}

@media (max-width: 991.98px) {
  .icon-card {
    .icon-wrapper {
      i {
        font-size: 4rem;
      }
    }
    .card-title {
      font-size: 1.5rem;
      margin-bottom: 0.5rem;
    }
  }
}

@media (max-width: 575.98px) {
  .icon-card {
    .icon-wrapper {
      i {
        margin-bottom: 1.5rem;
      }
    }

    .card-title,
    .card-text {
      text-align: center;
      padding: 0 1.5rem;
    }
  }
}
</style>
